import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
/**
 * @copyright 2016 commenthol
 * @license MIT
 */

import CalendarChinese from './Chinese.js';
var CalendarVietnamese = /*#__PURE__*/function (_CalendarChinese) {
  _inherits(CalendarVietnamese, _CalendarChinese);
  var _super = _createSuper(CalendarVietnamese);
  function CalendarVietnamese() {
    _classCallCheck(this, CalendarVietnamese);
    return _super.apply(this, arguments);
  }
  _createClass(CalendarVietnamese, [{
    key: "timeshiftUTC",
    value:
    /**
     * timeshift to UTC
     *
     * @param {CalendarGregorian} gcal - gregorian calendar date
     * @return {Number} timeshift in fraction of day
     */
    function timeshiftUTC(gcal) {
      if (gcal.toYear() >= 1968) {
        return 7 / 24; // +7:00:00h
      }
      return 8 / 24; // +8:00:00h Standard China time zone (120° East)
    }
  }]);
  return CalendarVietnamese;
}(CalendarChinese);
export { CalendarVietnamese as default };